import { currentWeatherImages } from './weather-images/current-weather-images';
import { weatherConditionImages } from './weather-images/weather-condition-images';
import { windDirectionImages } from './weather-images/wind-direction-images';

export const images = {
  currentWeather: currentWeatherImages,
  weatherCondition: weatherConditionImages,
  windDirection: windDirectionImages,
};
